import { useState } from "react";
import styles from "../../../styles/components/parts/view/PartsViewMobile.module.css";
import buttonStyles from "../../../styles/components/asset/requestButton.module.css";
import { periodNoDiv } from "../../../components/search";
import { packagingLabel, CUSTOM_REEL_LABEL } from "../../common/packaging";
import Head from "next/head";

export default function PartsViewMobile(props) {
  const {
    //상태
    item_data,
    item_info,
    item_code,
    it_name,
    it_basic,
    prices,
    multiple,
    min_qty,
    max_qty,
    unit_price,
    userType,
    manufacturer,
    manufacturer_str,
    it_maker,
    origin_pn,
    lifeCycle,
    packaging,
    hs_code,
    logistic_weather,
    banners,
    banners_mobile,
    bannerIndex,
    total_price,
    total_price_vat,
    // 커스텀 릴 옵션 (control-plane#13)
    reel_option,
    isReelSelected,
    can_toggle_reel,
    chooseReel,
    display_packaging,
    show_packaging,
    display_prices,
    display_item_code,
    display_origin_pn,
    display_datasheet,
    display_max_qty,
    display_min_qty,
    display_multiple,
    display_min_price,
    order_total_price,
    partner,
    isWish,
    it_id,
    is_stock,
    total_qty,
    originalPrice,
    salePrice,
    desiredValue,
    desiredPrice,
    // 기능
    goToDatasheet,
    handleMinus,
    handlePlus,
    lifecycleNew,
    check_vat,
    handleMinQtyChange,
    handleMinQtyChangeFoucsOut,
    _addWish,
    _removeWish,
    _AddCart,
    isNullPacakageCheck,
    setDesiredValue,
    setDesiredPrice,
    requestEstimate,
  } = props;
  // 모바일 카트 열리고 안열리고
  const [isCartOpen, setIsCartOpen] = useState(false);
  // --- 바텀시트 닫기 (control-plane#13) ---
  // 핸들을 잡고 내리는 중일 때 손가락을 따라 움직인 거리(px)
  const [dragY, setDragY] = useState(0);
  // 손가락이 처음 닿은 지점. null 이면 지금 잡고 있지 않다는 뜻
  const [dragStartY, setDragStartY] = useState(null);
  // 방금 잡고 움직였는지. 끌어내렸다 놓은 뒤에 따라 오는 click 이 시트를 또 닫지 않게 막는다
  const [didDrag, setDidDrag] = useState(false);

  // 이만큼 내리면 닫는다. 살짝 스친 것까지 닫아버리지 않을 만큼 잡았다.
  const SHEET_CLOSE_THRESHOLD = 60;
  // 이 정도 움직임은 손 떨림으로 보고 탭으로 친다
  const SHEET_DRAG_SLOP = 5;

  const closeSheet = () => {
    setIsCartOpen(false);
    setDragStartY(null);
    setDragY(0);
  };

  const onHandleTouchStart = (e) => {
    setDragStartY(e.touches[0].clientY);
    setDragY(0);
    setDidDrag(false);
  };
  const onHandleTouchMove = (e) => {
    if (dragStartY === null) return;
    // 위로 올리는 건 무시한다. 시트는 내려서 닫는 것만 된다.
    const moved = Math.max(0, e.touches[0].clientY - dragStartY);
    if (moved > SHEET_DRAG_SLOP) setDidDrag(true);
    setDragY(moved);
  };
  const onHandleTouchEnd = () => {
    if (dragStartY === null) return;
    if (dragY >= SHEET_CLOSE_THRESHOLD) {
      closeSheet();
      return;
    }
    // 덜 내렸으면 제자리로 되돌린다
    setDragStartY(null);
    setDragY(0);
  };
  // 핸들을 톡 누르기만 해도 닫힌다 (원래 동작 유지)
  const onHandleClick = () => {
    if (didDrag) {
      setDidDrag(false);
      return;
    }
    closeSheet();
  };

  // 릴을 고르지 않았을 때의 포장 이름.
  // 릴 주소로 바로 들어온 경우엔 지금 행이 릴이므로, 되돌아갈 형제(컷테이프 등)의 이름을 보여준다.
  const base_packaging_label =
    reel_option && reel_option.is_reel
      ? reel_option.base && reel_option.base.packaging
      : packaging;

  return (
    <>
      <Head>
        <title>{it_name}</title>
      </Head>

      <div className={styles.frame0}>
        <div className={styles.detailInfo}>
          <div className={styles.infoBox}>
            <div className={styles.imageOutFrame}>
              <div className={styles.imageBox}>
                <div className={styles.forCenterFrame}></div>
                {item_info?.it_img1?.trim() ? (
                  <img
                    src={item_info.it_img1}
                    alt={"image"}
                    className={styles.image}
                    onError={(e) => {
                      e.target.src = "/images/noimageKO.jpg";
                    }}
                  />
                ) : (
                  <img
                    src="/images/noimageKO.jpg"
                    alt="이미지 준비중"
                    className={styles.image}
                  />
                )}
                <div className={`${styles.text} caption2`}>
                  위 상품 이미지는 참고용이며, 실제 제품과 다를 수 있습니다.
                </div>
              </div>
            </div>
            <div className={styles.productInfoDetailGroup}>
              <div className={styles.productInfoBox}>
                <div className={styles.productInfo}>
                  <div className={styles.productNumberOutFrame}>
                    <div className={`${styles.productNumber} caption2`}>
                      {display_item_code}
                    </div>
                  </div>
                  <div className={styles.productNameSummaryGroup}>
                    <div className={`${styles.productName} headline1`}>
                      {it_name}
                    </div>
                    <div className={`${styles.summary} caption2`}>
                      {" "}
                      {it_basic
                        ? it_basic.length > 65
                          ? `${it_basic.slice(0, 65)}...`
                          : it_basic
                        : it_basic}
                    </div>
                  </div>
                </div>
                <div className={styles.deliveryBox}>
                  <div className={styles.moqPriceGroup}>
                    <div className={`${styles.price} title2`}>
                      <span>{display_min_price.toLocaleString()}원</span>
                    </div>
                  </div>
                  <div className={styles.deliveryDate}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M15.4644 6.8125L14.5894 4.625C14.5151 4.43982 14.3869 4.28123 14.2214 4.16978C14.0559 4.05834 13.8608 3.99919 13.6613 4H11.5V3.5C11.5 3.36739 11.4473 3.24021 11.3536 3.14645C11.2598 3.05268 11.1326 3 11 3H1.5C1.23478 3 0.98043 3.10536 0.792893 3.29289C0.605357 3.48043 0.5 3.73478 0.5 4V11C0.5 11.2652 0.605357 11.5196 0.792893 11.7071C0.98043 11.8946 1.23478 12 1.5 12H2.5625C2.67265 12.4302 2.92285 12.8115 3.27366 13.0838C3.62446 13.3561 4.05591 13.5039 4.5 13.5039C4.94409 13.5039 5.37554 13.3561 5.72635 13.0838C6.07715 12.8115 6.32735 12.4302 6.4375 12H9.5625C9.67265 12.4302 9.92285 12.8115 10.2737 13.0838C10.6245 13.3561 11.0559 13.5039 11.5 13.5039C11.9441 13.5039 12.3755 13.3561 12.7263 13.0838C13.0771 12.8115 13.3273 12.4302 13.4375 12H14.5C14.7652 12 15.0196 11.8946 15.2071 11.7071C15.3946 11.5196 15.5 11.2652 15.5 11V7C15.5001 6.93581 15.488 6.87219 15.4644 6.8125ZM4.5 12.5C4.30222 12.5 4.10888 12.4414 3.94443 12.3315C3.77998 12.2216 3.65181 12.0654 3.57612 11.8827C3.50043 11.7 3.48063 11.4989 3.51921 11.3049C3.5578 11.1109 3.65304 10.9327 3.79289 10.7929C3.93275 10.653 4.11093 10.5578 4.30491 10.5192C4.49889 10.4806 4.69996 10.5004 4.88268 10.5761C5.06541 10.6518 5.22159 10.78 5.33147 10.9444C5.44135 11.1089 5.5 11.3022 5.5 11.5C5.5 11.7652 5.39464 12.0196 5.20711 12.2071C5.01957 12.3946 4.76522 12.5 4.5 12.5ZM1.5 8V4H10.5V8H1.5ZM11.5 12.5C11.3022 12.5 11.1089 12.4414 10.9444 12.3315C10.78 12.2216 10.6518 12.0654 10.5761 11.8827C10.5004 11.7 10.4806 11.4989 10.5192 11.3049C10.5578 11.1109 10.653 10.9327 10.7929 10.7929C10.9327 10.653 11.1109 10.5578 11.3049 10.5192C11.4989 10.4806 11.7 10.5004 11.8827 10.5761C12.0654 10.6518 12.2216 10.78 12.3315 10.9444C12.4414 11.1089 12.5 11.3022 12.5 11.5C12.5 11.7652 12.3946 12.0196 12.2071 12.2071C12.0196 12.3946 11.7652 12.5 11.5 12.5ZM11.5 6.5V5H13.6613L14.2612 6.5H11.5Z"
                        fill="#7D8593"
                      />
                    </svg>
                    <div className={`${styles.minmumCnt} label2`}>
                      3,000원 (50,000원 이상 무료배송)
                    </div>
                  </div>
                </div>
              </div>
              {/* 제조사, 유통사, MPN, SKU, LifeCycle, 사양 */}
              <div className={styles.productDetailBox}>
                <div className={styles.frame00100110}>
                  <div className={styles.productDetailBox}>
                    <div className={styles.productDetail}>
                      <div className={styles.productDetailInfo}>
                        <div className={`${styles.productTitle} caption2`}>
                          제조사
                        </div>
                        <div className={`${styles.productContents} body4`}>
                          {manufacturer_str}
                        </div>
                      </div>
                      <div className={styles.productDetailInfo}>
                        <div className={`${styles.productTitle} caption2`}>
                          유통사
                        </div>
                        <div className={`${styles.productContents} body4`}>
                          {it_maker.toUpperCase()}
                        </div>
                      </div>
                      <div className={styles.productDetailInfo}>
                        <div className={`${styles.productTitle} caption2`}>
                          MPN
                        </div>
                        <div className={`${styles.productContents} body4`}>
                          {it_name}
                        </div>
                      </div>
                      <div className={styles.productDetailInfo}>
                        <div className={`${styles.productTitle} caption2`}>
                          SKU
                        </div>
                        <div className={`${styles.productContents} body4`}>
                          {display_origin_pn}
                        </div>
                      </div>
                      <div className={styles.lifeCycle}>
                        <div className={`${styles.productTitle} caption2`}>
                          Lifecycle
                        </div>
                        <div className={`${styles.productContents} body4`}>
                          <img
                            src={lifecycleNew(lifeCycle)}
                            className={styles.rectangle32}
                          ></img>
                        </div>
                      </div>
                      <div className={styles.specification}>
                        <div className={`${styles.productTitle} caption2`}>
                          사양
                        </div>
                        <div className={`${styles.specContents} caption2`}>
                          정확한 사양은 데이터시트에서 확인하세요.
                        </div>
                      </div>
                    </div>
                    {display_datasheet ? (
                      <>
                        <div
                          className={`${styles.buttonFillWhite} ${styles.cursorActive}`}
                          onClick={() => goToDatasheet(display_datasheet)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                              fill="#2F2F2F"
                            />
                          </svg>
                          <div className={`${styles.datasheet} body1`}>
                            데이터시트
                          </div>
                        </div>
                      </>
                    ) : (
                      <div
                        className={`${styles.buttonFillWhite} ${styles.datasheetDisable}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M13.3538 5.14625L9.85375 1.64625C9.80728 1.59983 9.75212 1.56303 9.69143 1.53793C9.63073 1.51284 9.56568 1.49995 9.5 1.5H3.5C3.23478 1.5 2.98043 1.60536 2.79289 1.79289C2.60536 1.98043 2.5 2.23478 2.5 2.5V13.5C2.5 13.7652 2.60536 14.0196 2.79289 14.2071C2.98043 14.3946 3.23478 14.5 3.5 14.5H12.5C12.7652 14.5 13.0196 14.3946 13.2071 14.2071C13.3946 14.0196 13.5 13.7652 13.5 13.5V5.5C13.5001 5.43432 13.4872 5.36927 13.4621 5.30858C13.437 5.24788 13.4002 5.19272 13.3538 5.14625ZM9.85375 10.3538L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L6.14625 10.3538C6.05243 10.2599 5.99972 10.1327 5.99972 10C5.99972 9.86732 6.05243 9.74007 6.14625 9.64625C6.24007 9.55243 6.36732 9.49972 6.5 9.49972C6.63268 9.49972 6.75993 9.55243 6.85375 9.64625L7.5 10.2931V7.5C7.5 7.36739 7.55268 7.24021 7.64645 7.14645C7.74021 7.05268 7.86739 7 8 7C8.13261 7 8.25979 7.05268 8.35355 7.14645C8.44732 7.24021 8.5 7.36739 8.5 7.5V10.2931L9.14625 9.64625C9.24007 9.55243 9.36732 9.49972 9.5 9.49972C9.63268 9.49972 9.75993 9.55243 9.85375 9.64625C9.94757 9.74007 10.0003 9.86732 10.0003 10C10.0003 10.1327 9.94757 10.2599 9.85375 10.3538ZM9.5 5.5V2.75L12.25 5.5H9.5Z"
                            fill="#2F2F2F"
                          />
                        </svg>
                        <div className={`${styles.datasheet} body1`}>
                          데이터시트
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.pointSaleGroup}>
            <div className={`${styles.point}`}>
              <div className={`${styles.pointTitle} caption2`}>적립</div>
              <div className={`${styles.pointContents} caption2`}>
                0.5% 포인트 추가 적립
              </div>
            </div>
            <div className={`${styles.sale}`}>
              <div className={`${styles.pointTitle} caption2`}>혜택</div>
              <div className={`${styles.salesGroup}`}>
                <div className={`${styles.saleTitle} caption2`}>
                  첫 구매 <span className={styles.redText}>3%할인</span>{" "}
                  (쿠폰적용시)
                </div>
                <div className={`${styles.saleTitle} caption2`}>
                  골드회원혜택가{" "}
                  <span className={styles.redText}>상시 2% 할인</span>
                </div>
              </div>
            </div>
            <div className={`${styles.delivery}`}>
              <div className={`${styles.deliveryText} caption2`}>배송</div>
              <div className={`${styles.deliveryGroup}`}>
                <div className={`${styles.saleTitle} caption2`}>
                  {logistic_weather.period_start} ~{" "}
                  {logistic_weather.period_end} 이내 출고 예정
                </div>
                <div className={`${styles.saleTitle} caption2`}>
                  {`${logistic_weather.weather_str}`}{" "}
                  <img
                    style={{ display: "inline" }}
                    src={`/images/weather/${logistic_weather.weather_txt}.png`}
                    width="18px"
                  />
                </div>
                <div className={`${styles.saleTitle} caption2`}>
                  배송비 3,000원 (50,000원 이상 무료)
                </div>
              </div>
            </div>
            {hs_code && (
              <div className={`${styles.point}`}>
                <div className={`${styles.pointTitle} caption2`}>HS코드</div>
                <div className={`${styles.pointContents} caption2`}>
                  {hs_code}
                </div>
              </div>
            )}
          </div>
          <div className={styles.customerInput}>
            <div className={styles.numberPurchaseControlGroup}>
              <div className={styles.numberbox}>
                <div className={styles.inventoryGroup}>
                  <div className={styles.iconCubeGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M13.98 4.13414L8.48 1.12477C8.33305 1.04357 8.16789 1.00098 8 1.00098C7.83211 1.00098 7.66695 1.04357 7.52 1.12477L2.02 4.13539C1.86293 4.22133 1.73181 4.34787 1.64034 4.50178C1.54888 4.6557 1.50041 4.83135 1.5 5.01039V10.9879C1.50041 11.1669 1.54888 11.3426 1.64034 11.4965C1.73181 11.6504 1.86293 11.777 2.02 11.8629L7.52 14.8735C7.66695 14.9547 7.83211 14.9973 8 14.9973C8.16789 14.9973 8.33305 14.9547 8.48 14.8735L13.98 11.8629C14.1371 11.777 14.2682 11.6504 14.3597 11.4965C14.4511 11.3426 14.4996 11.1669 14.5 10.9879V5.01102C14.4999 4.83166 14.4516 4.65561 14.3601 4.50134C14.2686 4.34706 14.1373 4.22024 13.98 4.13414ZM8 7.49977L2.97813 4.74977L8 1.99977L13.0219 4.74977L8 7.49977ZM8.5 13.7273V8.36414L13.5 5.62789V10.9879L8.5 13.7273Z"
                        fill="white"
                      />
                    </svg>

                    <div className={`${styles.stockText} caption1`}>재고</div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_max_qty.toLocaleString()}개
                  </div>
                </div>
                <div className={styles.moqGroup}>
                  <div className={styles.iconArrowsInGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M9.00028 6.49979V3.99979C9.0002 3.90084 9.02948 3.8041 9.08442 3.7218C9.13935 3.6395 9.21747 3.57535 9.30888 3.53748C9.40029 3.4996 9.50089 3.4897 9.59793 3.50903C9.69497 3.52835 9.7841 3.57603 9.85403 3.64604L10.7503 4.54291L12.6465 2.64604C12.7403 2.55222 12.8676 2.49951 13.0003 2.49951C13.133 2.49951 13.2602 2.55222 13.354 2.64604C13.4478 2.73986 13.5006 2.86711 13.5006 2.99979C13.5006 3.13247 13.4478 3.25972 13.354 3.35354L11.4572 5.24979L12.354 6.14604C12.424 6.21597 12.4717 6.30509 12.491 6.40214C12.5104 6.49918 12.5005 6.59977 12.4626 6.69118C12.4247 6.7826 12.3606 6.86071 12.2783 6.91565C12.196 6.97059 12.0992 6.99987 12.0003 6.99979H9.50028C9.36767 6.99979 9.24049 6.94711 9.14672 6.85334C9.05296 6.75957 9.00028 6.6324 9.00028 6.49979ZM6.50028 8.99979H4.00028C3.90133 8.99971 3.80458 9.02899 3.72229 9.08393C3.63999 9.13886 3.57584 9.21698 3.53797 9.30839C3.50009 9.39981 3.49019 9.5004 3.50951 9.59744C3.52884 9.69449 3.57652 9.78361 3.64653 9.85354L4.5434 10.7498L2.64653 12.646C2.55271 12.7399 2.5 12.8671 2.5 12.9998C2.5 13.1325 2.55271 13.2597 2.64653 13.3535C2.74035 13.4474 2.8676 13.5001 3.00028 13.5001C3.13296 13.5001 3.26021 13.4474 3.35403 13.3535L5.25028 11.4567L6.14653 12.3535C6.21646 12.4235 6.30558 12.4712 6.40262 12.4906C6.49967 12.5099 6.60026 12.5 6.69167 12.4621C6.78308 12.4242 6.8612 12.3601 6.91614 12.2778C6.97107 12.1955 7.00036 12.0987 7.00028 11.9998V9.49979C7.00028 9.36718 6.9476 9.24 6.85383 9.14624C6.76006 9.05247 6.63289 8.99979 6.50028 8.99979ZM6.69153 3.53791C6.60018 3.50002 6.49964 3.49006 6.40263 3.50931C6.30562 3.52855 6.21649 3.57614 6.14653 3.64604L5.25028 4.54291L3.35403 2.64604C3.26021 2.55222 3.13296 2.49951 3.00028 2.49951C2.8676 2.49951 2.74035 2.55222 2.64653 2.64604C2.55271 2.73986 2.5 2.86711 2.5 2.99979C2.5 3.13247 2.55271 3.25972 2.64653 3.35354L4.5434 5.24979L3.64653 6.14604C3.57652 6.21597 3.52884 6.30509 3.50951 6.40214C3.49019 6.49918 3.50009 6.59977 3.53797 6.69118C3.57584 6.7826 3.63999 6.86071 3.72229 6.91565C3.80458 6.97059 3.90133 6.99987 4.00028 6.99979H6.50028C6.63289 6.99979 6.76006 6.94711 6.85383 6.85334C6.9476 6.75957 7.00028 6.6324 7.00028 6.49979V3.99979C7.00026 3.9009 6.97091 3.80424 6.91596 3.72202C6.861 3.63981 6.7829 3.57574 6.69153 3.53791ZM11.4572 10.7498L12.354 9.85354C12.424 9.78361 12.4717 9.69449 12.491 9.59744C12.5104 9.5004 12.5005 9.39981 12.4626 9.30839C12.4247 9.21698 12.3606 9.13886 12.2783 9.08393C12.196 9.02899 12.0992 8.99971 12.0003 8.99979H9.50028C9.36767 8.99979 9.24049 9.05247 9.14672 9.14624C9.05296 9.24 9.00028 9.36718 9.00028 9.49979V11.9998C9.0002 12.0987 9.02948 12.1955 9.08442 12.2778C9.13935 12.3601 9.21747 12.4242 9.30888 12.4621C9.40029 12.5 9.50089 12.5099 9.59793 12.4906C9.69497 12.4712 9.7841 12.4235 9.85403 12.3535L10.7503 11.4567L12.6465 13.3535C12.693 13.4 12.7481 13.4368 12.8088 13.462C12.8695 13.4871 12.9346 13.5001 13.0003 13.5001C13.066 13.5001 13.131 13.4871 13.1917 13.462C13.2524 13.4368 13.3076 13.4 13.354 13.3535C13.4005 13.3071 13.4373 13.2519 13.4625 13.1912C13.4876 13.1305 13.5006 13.0655 13.5006 12.9998C13.5006 12.9341 13.4876 12.869 13.4625 12.8083C13.4373 12.7476 13.4005 12.6925 13.354 12.646L11.4572 10.7498Z"
                        fill="white"
                      />
                    </svg>

                    <div className={`${styles.stockText} caption1`}>
                      최소수량
                    </div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_min_qty.toLocaleString()}개
                  </div>
                </div>
                <div className={styles.multipleGroup}>
                  <div className={styles.iconUnitsGroup}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.25 3.25V5.75H1.75C1.6837 5.75 1.62011 5.72366 1.57322 5.67678C1.52634 5.62989 1.5 5.5663 1.5 5.5V4C1.5 3.73478 1.60536 3.48043 1.79289 3.29289C1.98043 3.10536 2.23478 3 2.5 3H5C5.0663 3 5.12989 3.02634 5.17678 3.07322C5.22366 3.12011 5.25 3.1837 5.25 3.25ZM6.25 12.75C6.25 12.8163 6.27634 12.8799 6.32322 12.9268C6.37011 12.9737 6.4337 13 6.5 13H9.5C9.5663 13 9.62989 12.9737 9.67678 12.9268C9.72366 12.8799 9.75 12.8163 9.75 12.75V10.25H6.25V12.75ZM1.5 10.5V12C1.5 12.2652 1.60536 12.5196 1.79289 12.7071C1.98043 12.8946 2.23478 13 2.5 13H5C5.0663 13 5.12989 12.9737 5.17678 12.9268C5.22366 12.8799 5.25 12.8163 5.25 12.75V10.25H1.75C1.6837 10.25 1.62011 10.2763 1.57322 10.3232C1.52634 10.3701 1.5 10.4337 1.5 10.5ZM1.5 7V9C1.5 9.0663 1.52634 9.12989 1.57322 9.17678C1.62011 9.22366 1.6837 9.25 1.75 9.25H5.25V6.75H1.75C1.6837 6.75 1.62011 6.77634 1.57322 6.82322C1.52634 6.87011 1.5 6.9337 1.5 7ZM9.5 3H6.5C6.4337 3 6.37011 3.02634 6.32322 3.07322C6.27634 3.12011 6.25 3.1837 6.25 3.25V5.75H9.75V3.25C9.75 3.1837 9.72366 3.12011 9.67678 3.07322C9.62989 3.02634 9.5663 3 9.5 3ZM14.25 6.75H10.75V9.25H14.25C14.3163 9.25 14.3799 9.22366 14.4268 9.17678C14.4737 9.12989 14.5 9.0663 14.5 9V7C14.5 6.9337 14.4737 6.87011 14.4268 6.82322C14.3799 6.77634 14.3163 6.75 14.25 6.75ZM6.25 9.25H9.75V6.75H6.25V9.25ZM13.5 3H11C10.9337 3 10.8701 3.02634 10.8232 3.07322C10.7763 3.12011 10.75 3.1837 10.75 3.25V5.75H14.25C14.3163 5.75 14.3799 5.72366 14.4268 5.67678C14.4737 5.62989 14.5 5.5663 14.5 5.5V4C14.5 3.73478 14.3946 3.48043 14.2071 3.29289C14.0196 3.10536 13.7652 3 13.5 3ZM14.25 10.25H10.75V12.75C10.75 12.8163 10.7763 12.8799 10.8232 12.9268C10.8701 12.9737 10.9337 13 11 13H13.5C13.7652 13 14.0196 12.8946 14.2071 12.7071C14.3946 12.5196 14.5 12.2652 14.5 12V10.5C14.5 10.4337 14.4737 10.3701 14.4268 10.3232C14.3799 10.2763 14.3163 10.25 14.25 10.25Z"
                        fill="white"
                      />
                    </svg>
                    <div className={`${styles.stockText} caption1`}>
                      구매단위
                    </div>
                  </div>
                  <div className={`${styles.stockCount} body1`}>
                    {display_multiple.toLocaleString()}개
                  </div>
                </div>
              </div>
              <div className={styles.selectQuantityGroup}>
                <div className={styles.selectQuantityheadline}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M11.5554 2.6665H4.44428C3.46244 2.6665 2.6665 3.46244 2.6665 4.44428V11.5554C2.6665 12.5372 3.46244 13.3332 4.44428 13.3332H11.5554C12.5372 13.3332 13.3332 12.5372 13.3332 11.5554V4.44428C13.3332 3.46244 12.5372 2.6665 11.5554 2.6665Z"
                      fill="#2F2F2F"
                    />
                  </svg>
                  <div className={`${styles.moqInformation} body1`}>
                    단가정보
                  </div>
                </div>
                <div className={styles.selectQuantityBox}>
                  <div className={styles.quantityCostBoxGroup}>
                    {display_prices.length > 0
                      ? display_prices.map((el, idx) => {
                          // 내림차순 기준 → upper boundary = 앞 tier의 Quantity
                          const upperBound =
                            idx === 0
                              ? Infinity
                              : display_prices[idx - 1].Quantity;

                          const isActive =
                            total_qty >= el.Quantity && total_qty < upperBound;

                          return (
                            <div
                              className={styles.quantityCostBox}
                              key={el.Quantity}
                            >
                              <div
                                className={`${
                                  isActive
                                    ? styles.quantityCostBoxTextActive
                                    : styles.quantityCostBoxText
                                } headline3`}
                              >
                                {el.Quantity}+
                              </div>

                              <div className={styles.costGroup}>
                                <div
                                  className={`${styles.costCancelText} body2`}
                                >
                                  {userType === "affilate_member" ||
                                  userType === "discount_member"
                                    ? el.price_before.toLocaleString() + "원"
                                    : ""}
                                </div>

                                <div
                                  className={`${
                                    isActive
                                      ? styles.quantityCostBoxTextActive
                                      : styles.quantityCostBoxText
                                  } headline3`}
                                >
                                  {userType === "affilate_member" ||
                                  userType === "discount_member"
                                    ? el.Price.toLocaleString() + "원"
                                    : el.price_before.toLocaleString() + "원"}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      : ""}
                    {/* <div className={styles.quantityCostBox}>
                      <div
                        className={`${styles.quantityCostBoxTextActive} body1`}
                      >
                        200개+
                      </div>
                      <div className={styles.costGroup}>
                        <div className={`${styles.costCancelText} caption2`}>
                          2,500원
                        </div>
                        <div
                          className={`${styles.quantityCostBoxTextActive} body1`}
                        >
                          2,400원
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              {/* 회원혜택가 안내 — 단가정보 아래 */}
              {userType === "affilate_member" ||
              userType === "discount_member" ? (
                <>
                  <div className={styles.sectionMessageAffiliate}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.5 5C7.5 4.86739 7.55268 4.74021 7.64645 4.64645C7.74022 4.55268 7.86739 4.5 8 4.5C8.13261 4.5 8.25979 4.55268 8.35356 4.64645C8.44732 4.74021 8.5 4.86739 8.5 5V8.5C8.5 8.63261 8.44732 8.75979 8.35356 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74022 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V5ZM8 11.5C7.85167 11.5 7.70666 11.456 7.58333 11.3736C7.45999 11.2912 7.36386 11.1741 7.30709 11.037C7.25033 10.9 7.23547 10.7492 7.26441 10.6037C7.29335 10.4582 7.36478 10.3246 7.46967 10.2197C7.57456 10.1148 7.7082 10.0433 7.85368 10.0144C7.99917 9.98547 8.14997 10.0003 8.28701 10.0571C8.42406 10.1139 8.54119 10.21 8.6236 10.3333C8.70602 10.4567 8.75 10.6017 8.75 10.75C8.75 10.9489 8.67098 11.1397 8.53033 11.2803C8.38968 11.421 8.19892 11.5 8 11.5Z"
                        fill="#69A2FF"
                      />
                    </svg>
                    <div className={`${styles.announcement} caption2`}>
                      <span className={`${styles.announcement} caption1`}>
                        일반회원가
                      </span>{" "}
                      <span className={`${styles.titleColorBlue} caption1`}>
                        {(originalPrice - salePrice).toLocaleString()}원
                      </span>{" "}
                      더 할인되었습니다.
                    </div>{" "}
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.sectionMessage}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.4982 6.27665 13.8128 4.62441 12.5942 3.40582C11.3756 2.18722 9.72335 1.50182 8 1.5ZM7.5 5C7.5 4.86739 7.55268 4.74021 7.64645 4.64645C7.74022 4.55268 7.86739 4.5 8 4.5C8.13261 4.5 8.25979 4.55268 8.35356 4.64645C8.44732 4.74021 8.5 4.86739 8.5 5V8.5C8.5 8.63261 8.44732 8.75979 8.35356 8.85355C8.25979 8.94732 8.13261 9 8 9C7.86739 9 7.74022 8.94732 7.64645 8.85355C7.55268 8.75979 7.5 8.63261 7.5 8.5V5ZM8 11.5C7.85167 11.5 7.70666 11.456 7.58333 11.3736C7.45999 11.2912 7.36386 11.1741 7.30709 11.037C7.25033 10.9 7.23548 10.7492 7.26441 10.6037C7.29335 10.4582 7.36478 10.3246 7.46967 10.2197C7.57456 10.1148 7.7082 10.0434 7.85368 10.0144C7.99917 9.98547 8.14997 10.0003 8.28701 10.0571C8.42406 10.1139 8.54119 10.21 8.6236 10.3333C8.70602 10.4567 8.75 10.6017 8.75 10.75C8.75 10.9489 8.67098 11.1397 8.53033 11.2803C8.38968 11.421 8.19892 11.5 8 11.5Z"
                        fill="#F7323F"
                      />
                    </svg>
                    <div className={`${styles.announcement} caption2`}>
                      <span className={`${styles.announcement} caption1`}>
                        회원혜택가
                      </span>{" "}
                      <span className={`${styles.titleColor} caption1`}>
                        {(originalPrice - salePrice).toLocaleString()}원
                      </span>{" "}
                      더 할인됩니다.
                    </div>{" "}
                  </div>
                </>
              )}
            </div>
            <div className={styles.customizedUnitBox}>
              <div className={styles.customizedUnitHeadline}>
                <div className={`${styles.needQuoteText} title2`}>
                  맞춤 단가가 필요하세요?
                </div>
                <div className={`${styles.needQuoteContent} body2`}>
                  필요 수량과 희망 가격을 알려주시면, <br></br>
                  수량별 최적 단가로 특별 혜택을 안내해 드려요.
                </div>
              </div>
              <div className={styles.inputControl}>
                <div className={styles.inputGroup}>
                  {/* 필요수량 Input */}
                  <div className={styles.textInput}>
                    <div
                      className={`${styles.inputBoxNoHeader} ${styles.inputBoxActive}`}
                    >
                      <input
                        value={desiredValue}
                        onChange={(e) => setDesiredValue(e.target.value)}
                        type="number"
                        className={styles.customInput}
                        placeholder="필요수량"
                      />
                    </div>
                  </div>

                  {/* 희망가격 Input */}
                  <div className={styles.textInput}>
                    <div
                      className={`${styles.inputBoxNoHeader} ${styles.inputBoxActive}`}
                    >
                      <input
                        value={desiredPrice}
                        onChange={(e) => setDesiredPrice(e.target.value)}
                        type="number"
                        className={styles.customInput}
                        placeholder="희망가격"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={buttonStyles.buttonGroup}
                  onClick={() =>
                    requestEstimate({
                      it_name,
                      manufacturer: manufacturer,
                    })
                  }
                >
                  {/* 🔥 견적 바로받기 버튼에 requestEstimate 연결 */}
                  <div className={buttonStyles.requestButton}>
                    <div className={buttonStyles.iconLightning}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <div className={`${buttonStyles.bodyiconLigthing} body1`}>
                      견적바로받기
                    </div>
                  </div>

                  <div className={buttonStyles.iconChevronRight}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M5.29289 3.29289C5.68342 2.90237 6.31643 2.90237 6.70696 3.29289L10.707 7.29289C10.8945 7.48043 10.9999 7.73471 10.9999 7.99992C10.9999 8.26514 10.8945 8.51942 10.707 8.70696L6.70696 12.707C6.31643 13.0975 5.68342 13.0975 5.29289 12.707C4.90237 12.3164 4.90237 11.6834 5.29289 11.2929L8.58586 7.99992L5.29289 4.70696C4.90237 4.31643 4.90237 3.68342 5.29289 3.29289Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.bannerOutFrame}>
            <div
              className={[
                styles.bannerOutFrameWrapper,
                bannerIndex === 0 && styles.bg0,
                bannerIndex === 1 && styles.bg1,
                bannerIndex === 2 && styles.bg2,
              ]
                .filter(Boolean)
                .join(" ")}
            >
              <a
                href="/board/board_view?no=80&type=notice"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={banners_mobile[bannerIndex]}
                  alt="banner"
                  className={`${styles.banner}  body1`}
                />
              </a>
            </div>
          </div>
          <div className={styles.noticeGroup}>
            <div className={styles.deliveryNotice}>
              <div className={`${styles.deliveryNoticehedline} body3`}>
                배송안내
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} caption2`}>
                  배송비
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  제주도 및 기타 섬지역은 항공료 및 선박료가 추가 될 수
                  있습니다. <br></br>또한 제품의 무게 및 크기에 따라 추가
                  배송비가 발생될 수 있으니, 이점 양해 바랍니다.
                </div>
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} caption2`}>
                  배송기간
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  당일 해외 발주 마감은 유통사 15시 / 17시로 나누어 2회 발주를
                  진행합니다. <br></br>평균적으로 국내재고 상품은 입금 후 2~3일,
                  해외재고는 입금 확인 후 3~15일이내 출고 됩니다. <br></br>(도서
                  산간 지역은 1~2일 더 소요될 수 있습니다.) <br></br>예상
                  출고일이상 배송지연이 발생시 배송지연 보상을 해드립니다.{" "}
                  <br></br> 단, 금요일 17시 이후 입금건은 월요일에 주문처리
                  됩니다. <br></br>휴일 주문(토/일, 법정공휴일)의 경우 다음
                  영업일에 상품준비가 이루어집니다. <br></br>
                </div>
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} caption2`}>
                  배송방법
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  택배 - 로젠택배(1588-9988)<br></br>(발송 후 평균 1~2일 내
                  수령가능하며, 택배사의 사정에 따라 다소 지연 될 수 있습니다.)
                  <br></br>
                  퀵서비스 - 퀵서비스는 구매자 부담 (착불) 입니다. <br></br>
                  퀵서비스는 서울/경기 일부 지역에서 가능합니다. 기타 화물등의
                  배송은 지원하지 않습니다.
                </div>
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                  통관 및 관세
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  해외 재고 상품의 수입 및 통관 절차는 판다파츠가 통합 관리하여
                  진행합니다.
                  <br></br>
                  번거로운 통관 확인 절차없이, 빠르고 편리하게 주문하실 수
                  있습니다.
                  <br></br>
                  단, 품목에 따라 관세가 발생할 수 있으며, 출고 전 관세 납부를
                  요청드릴 수 있습니다.
                </div>
              </div>
            </div>
            <div className={styles.deliveryNotice}>
              <div className={`${styles.deliveryNoticehedline} body1`}>
                교환/환불 안내
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                  20일 교환/환불
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  제품 수령 후 20일이내에 다음과 같은 사항이 발생된 경우에
                  교환이 가능합니다.<br></br>
                  배송된 제품에 하자가 있거나, 기능상 문제가 발생한 경우
                  <br></br>
                  해외 재고 주문 상품은 상품의 하자가 아닌 경우(단순변심, 주문
                  실수)에 환불/취소가 불가능합니다.(해당 유통사 정책)<br></br>
                  주문 스펙 및 커팅, 릴제조 상품의 경우 교환/반품이 되지
                  않습니다.<br></br>
                  ESD에 민감한 부품은 환불이 불가 할 수도 있습니다.<br></br>
                  해외 주문 상품은 반품 시 해외 배송비 (4만원)가 부과될 수
                  있습니다.<br></br>
                  견적을 통해 별도로 구입한 물품은 구매 취소 및 반품이 불가 할
                  수 있습니다.<br></br>
                  Mil-Spec제품은 취소 및 반품이 불가능합니다.<br></br>
                  사전에 ‘취소 불가 / 반품 불가’로 지정된 부품은 반품 환불 불가
                  <br></br>
                  제조사에서 보증하는 반품은 제조사 보증 및 반품/교환 조건의
                  정책에 따라 다릅니다.<br></br>
                  기술 지원은 제품 특성에 따라 제조사 또는 유통사로 직접
                  문의해야 할 수도 있습니다.<br></br>
                  Chip Outpost 제품으로 지정된 부품은 반품할 수 없습니다.
                  <br></br>
                  불가항력 : 제품 분배, 원자재 부족, 노동 쟁의, 운송 지연,
                  예상치 못한 상황, 천재지변, 제3자의 작위 또는 부작위, 행정
                  또는 군사 당국의 작위 또는 부작위, 정부의 우선순위, 화재,
                  파업, 홍수, 악천후, 컴퓨터 고장, 테러, 전염병, 격리 규제, 폭동
                  또는 전쟁 등을 포함하되 이에 국한되지 않고 합리적인 통제를
                  벗어나는 이유로 인한 배송 지연 또는 의무 불이행에 대해
                  배상책임을 지지 않습니다.<br></br>
                </div>
              </div>
              <div className={`${styles.deliveryNoticeBody}`}>
                <div className={`${styles.deliveryNoticeBodyTitle} body4`}>
                  관세
                </div>
                <div className={`${styles.deliveryNoticeBodyContent} caption2`}>
                  교환의 경우 로젠택배를 통해서 반품해 주셔야 합니다. <br></br>
                  타 택배와 착불로 교환/반품 요청시 통보 없이 반송처리 됩니다.
                  <br></br>
                  모든 제품은 공급사의 사정에 따라 단가변동 및 재고 소진이 발생
                  될수 있습니다.<br></br> 급작스러운 환율 변동에 의해 추가
                  금액을 요청 할수 도 있으니, 양해바랍니다.<br></br> 제품의
                  사용법등의 문의는 제조사에 직접 문의를 해야합니다.<br></br>
                  판다파츠는 글로벌 공식 유통사와 제조사의 API를 통해 구매를
                  안전하고 간편하게 지원하는 서비스입니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 푸터 따라다니는 버튼 */}
      {/* 배경 — 누르면 시트가 닫힌다 */}
      {isCartOpen ? (
        <div className={styles.cartModalDim} onClick={closeSheet}></div>
      ) : null}
      {/* 잡고 내리는 동안엔 손가락을 그대로 따라가야 해서 style 로 애니메이션을 끈다 */}
      <div
        className={`${styles.cartModal} ${
          isCartOpen ? styles.cartModalOpen : styles.cartModalClose
        } body3`}
        style={
          dragY > 0
            ? { transform: `translateY(${dragY}px)`, transition: "none" }
            : undefined
        }
      >
        {/* 핸들 — 톡 눌러도, 잡고 내려도 닫힌다 */}
        <div
          className={styles.bottomSheetHandle}
          onTouchStart={onHandleTouchStart}
          onTouchMove={onHandleTouchMove}
          onTouchEnd={onHandleTouchEnd}
          onClick={onHandleClick}
        >
          <div className={styles.handle}></div>
        </div>
        <div className={styles.purchaseControlGroup}>
          <div className={styles.purchaseControlBox}>
            {/* 배송 → 수량·패키징 → 주문금액 순서로 세 덩이를 구분선으로 나눈다 */}
            <div className={styles.deliveryBoxRight}>
              <div className={styles.deliveryDateGroup}>
                <div className={`${styles.deliveryBoxRightText} body2`}>
                  배송기간
                </div>
                <div className={styles.deliveryDateRight}>
                  <div className={`${styles.totalPriceCnt} body3`}>
                    {periodNoDiv(partner)}
                    <span className={`body4`}>일</span>
                  </div>
                  <div className={styles.labelDelivery}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M11.2505 22.5005L8.25049 22.5005C8.05157 22.5005 7.86081 22.4215 7.72016 22.2808C7.5795 22.1402 7.50049 21.9494 7.50049 21.7505C7.50037 21.701 7.5054 21.6517 7.51549 21.6033L8.90674 14.6255L6.68205 14.6255L5.02736 16.2811C4.88751 16.4208 4.69816 16.4997 4.50049 16.5005L2.25049 16.5005C2.12757 16.5007 2.00648 16.4707 1.89788 16.4131C1.78928 16.3555 1.69649 16.2721 1.62769 16.1703C1.55888 16.0684 1.51617 15.9512 1.50331 15.829C1.49045 15.7067 1.50783 15.5832 1.55393 15.4692L2.94236 12.0005L1.55393 8.53174C1.50783 8.41779 1.49045 8.29425 1.50331 8.17201C1.51617 8.04976 1.55889 7.93255 1.62769 7.83069C1.69649 7.72883 1.78928 7.64544 1.89788 7.58786C2.00648 7.53028 2.12757 7.50028 2.25049 7.50049L4.50049 7.50049C4.59901 7.50041 4.69658 7.51974 4.78763 7.55739C4.87867 7.59503 4.96141 7.65024 5.03111 7.71986L6.6858 9.37549L8.90674 9.37549L7.51549 2.39768C7.5054 2.34927 7.50037 2.29994 7.50049 2.25049C7.50049 2.05158 7.5795 1.86081 7.72016 1.72016C7.86081 1.57951 8.05158 1.50049 8.25049 1.50049L11.2505 1.50049C11.3898 1.50039 11.5264 1.5391 11.645 1.6123C11.7636 1.68549 11.8594 1.79026 11.9217 1.91486L15.6511 9.37549L19.8755 9.37549C20.5717 9.37549 21.2394 9.65205 21.7316 10.1443C22.2239 10.6366 22.5005 11.3043 22.5005 12.0005C22.5005 12.6967 22.2239 13.3644 21.7316 13.8566C21.2394 14.3489 20.5717 14.6255 19.8755 14.6255L15.6511 14.6255L11.9217 22.0861C11.8594 22.2107 11.7636 22.3155 11.645 22.3887C11.5264 22.4619 11.3898 22.5006 11.2505 22.5005Z"
                        fill="#69A2FF"
                      />
                    </svg>
                    <div className={`${styles.globalText} label1`}>해외</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${styles.rowDivider} ${styles.rowDividerBeforeOption}`}
            ></div>
            <div className={styles.orderOptionGroup}>
              <div className={styles.selectQuantity}>
                <div className={`${styles.selectQuantityText} body2`}>수량</div>
                <div className={styles.numberInput}>
                  <div
                    className={
                      `${styles.buttonIcon} ` +
                      `${
                        display_min_qty !== total_qty
                          ? styles.cursorPointerActive
                          : ""
                      } ` +
                      `headline2`
                    }
                    onClick={handleMinus}
                  >
                    {display_min_qty === total_qty ? (
                      // 연한 회색 아이콘
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M12.6666 7C13.2189 7 13.6666 7.44773 13.6666 8C13.6666 8.55227 13.2189 9 12.6666 9H3.33325C2.78097 9 2.33325 8.55227 2.33325 8C2.33325 7.44773 2.78097 7 3.33325 7H12.6666Z"
                          fill="#B6BCC9"
                        />
                      </svg>
                    ) : (
                      // 기존 아이콘 (짙은 색)
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M12.6668 7C13.2191 7 13.6668 7.44773 13.6668 8C13.6668 8.55227 13.2191 9 12.6668 9H3.3335C2.78121 9 2.3335 8.55227 2.3335 8C2.3335 7.44773 2.78121 7 3.3335 7H12.6668Z"
                          fill="#2F2F2F"
                        />
                      </svg>
                    )}
                  </div>
                  <input
                    type="text"
                    inputMode="numeric"
                    pattern="\d*"
                    className={`${styles.inputButton} body1`}
                    value={total_qty}
                    onChange={(e) => handleMinQtyChange(e.target.value)}
                    onBlur={(e) => handleMinQtyChangeFoucsOut(e.target.value)}
                  />
                  <div
                    className={
                      `${styles.buttonIcon} ` +
                      `${
                        display_max_qty !== total_qty
                          ? styles.cursorPointerActive
                          : ""
                      } ` +
                      `headline2`
                    }
                    onClick={handlePlus}
                  >
                    {display_max_qty === total_qty ? (
                      // 연한 회색 아이콘
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.99992 12.6668V9.00016H3.33325C2.78097 9.00016 2.33325 8.55243 2.33325 8.00016C2.33325 7.4479 2.78097 7.00016 3.33325 7.00016H6.99992V3.3335C6.99992 2.78121 7.44765 2.3335 7.99992 2.3335C8.55219 2.3335 8.99992 2.78121 8.99992 3.3335V7.00016H12.6666C13.2189 7.00016 13.6666 7.4479 13.6666 8.00016C13.6666 8.55243 13.2189 9.00016 12.6666 9.00016H8.99992V12.6668C8.99992 13.2191 8.55219 13.6668 7.99992 13.6668C7.44765 13.6668 6.99992 13.2191 6.99992 12.6668Z"
                          fill="#B6BCC9"
                        />
                      </svg>
                    ) : (
                      // 기존 아이콘 (짙은 색)
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6.99967 12.6668V9.00016H3.33301C2.78072 9.00016 2.33301 8.55243 2.33301 8.00016C2.33301 7.4479 2.78072 7.00016 3.33301 7.00016H6.99967V3.3335C6.99967 2.78121 7.44741 2.3335 7.99967 2.3335C8.55194 2.3335 8.99967 2.78121 8.99967 3.3335V7.00016H12.6663C13.2186 7.00016 13.6663 7.4479 13.6663 8.00016C13.6663 8.55243 13.2186 9.00016 12.6663 9.00016H8.99967V12.6668C8.99967 13.2191 8.55194 13.6668 7.99967 13.6668C7.44741 13.6668 6.99967 13.2191 6.99967 12.6668Z"
                          fill="#2F2F2F"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
              {/* 패키징 줄은 디지키 상품에서만 (control-plane#13) */}
              {show_packaging && (
                <div className={styles.selectQuantity}>
                  <div className={`${styles.selectQuantityText} body2`}>
                    패키징
                  </div>
                  {/* 릴 형제가 있으면 고를 수 있게, 없으면 지금처럼 텍스트로.
                      고르는 자리를 주문금액 바로 위에 둬서 금액이 오르는 게 보이게 한다.
                      (control-plane#13 : 릴 수수료를 못 보고 넘어가던 것이 문제의 핵심) */}
                  {can_toggle_reel ? (
                    <select
                      className={`${styles.packagingSelect} body3`}
                      value={isReelSelected ? "reel" : "base"}
                      onChange={(e) => chooseReel(e.target.value === "reel")}
                    >
                      <option value="base">
                        {isNullPacakageCheck(
                          packagingLabel(base_packaging_label)
                        )}
                      </option>
                      <option value="reel">
                        {CUSTOM_REEL_LABEL} (+{reel_option.fee.toLocaleString()}
                        원)
                      </option>
                    </select>
                  ) : (
                    <div className={`${styles.packagingStatic} body3`}>
                      {isNullPacakageCheck(packagingLabel(display_packaging))}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div
              className={`${styles.rowDivider} ${styles.rowDividerBeforePrice}`}
            ></div>
            <div className={styles.totalPriceGroup}>
              <div className={`${styles.totalPriceCnt} body2`}>주문금액 </div>
              <div className={styles.totalPrice}>
                <div className={`${styles.totalPriceCnt} headline2`}>
                  <span className={`${styles.countRed} title2`}>
                    <span>{order_total_price.toLocaleString()}원</span>{" "}
                  </span>
                </div>
                {/* 부가세 안내는 금액 바로 아래에 둔다. 위에 두면 "주문금액" 라벨이 두 번 나온다 */}
                <div className={`${styles.totalPriceVat} caption2`}>
                  부가세 10% 미포함
                </div>
              </div>
            </div>
            {/* 장바구니 담기 — 시트 안 단독 풀폭. 찜은 지금 동작하지 않는 기능이라 뺐다 */}
            <div className={styles.buttonGroup}>
              <div
                className={styles.buttonFillPrimary}
                onClick={() => {
                  _AddCart(
                    it_id,
                    total_qty,
                    it_maker,
                    origin_pn,
                    packaging,
                    is_stock
                  );
                }}
              >
                <div className={`${styles.cartIconText} body3`}>
                  장바구니 담기
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 고정 바텀바 — 누르면 시트가 열린다. 실제로 담는 버튼은 시트 안에 있다.
          찜은 지금 동작하지 않는 기능이라 뺐다. (control-plane#13) */}
      <div
        className={`${styles.bottomSheetButton} ${
          isCartOpen ? styles.bottomSheetButtonHidden : ""
        }`}
      >
        <div
          className={styles.buttonFillPrimary}
          onClick={() => setIsCartOpen(true)}
        >
          <div className={`${styles.cartIconText} body3`}>장바구니 담기</div>
        </div>
      </div>
      {/* 푸터 장바구니 누르면 버튼이 스르륵 올라오는 것 */}
    </>
  );
}
